// extracted by mini-css-extract-plugin
export default {"locationDropdown":"LocationDropdown_locationDropdown__9-Kks"};